import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: {
            top: theme.spacing[12],
            bottom: theme.spacing[12],
            left: theme.spacing[40],
            right: theme.spacing[16]
        },
        '&:hover': {
            backgroundColor: theme.dropdown.list.hoverBackground
        },
        '&:focus': {
            outline: 'none',
            border: theme.dropdown.list.item.borderFocus
        },
        border: theme.borders.transparent

    },
    checkIcon: {
        marginRight: '1rem',
        color: theme.colors.grey800,
        fontWeight: theme.fontWeight.bold,
        width: '1.4rem',
        height: '1.4rem'
    },
    itemSelected: {
        color: theme.colors.grey800,
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize.sm
    },
    item: {
        marginLeft: '2.4rem',
        fontWeight: theme.fontWeight.normal,
        fontSize: theme.fontSize.sm
    }
}));

const MenuItem = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const optionRef = useRef();

    const { selected, value, children, onChange, focusedIndex, index } = props;

    const handleClick = () => {
        onChange(value);
    };

    useEffect(
        () => {
            if (focusedIndex === index && optionRef.current) {
                optionRef.current.focus();
            }
        }, [focusedIndex]
    );

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleClick();
        }
    };

    return (
        <li
            ref={optionRef}
            className={classNames('test-menuItem', classes.container)}
            data-value={value}
            role="option"
            aria-selected={selected && Boolean(true)}
            tabIndex={0}
            onClick={handleClick}
            onMouseDown={(e) => { e.preventDefault(); }}
            onKeyDown={handleKeyDown}
        >
            {
                selected && <FontAwesomeIcon className={classes.checkIcon} icon={faCheck} />
            }
            <Typography className={selected ? classes.itemSelected : classes.item}>{children}</Typography>
        </li>
    );
};

MenuItem.propTypes = {
    selected: PropTypes.bool,
    value: PropTypes.string,
    children: PropTypes.string,
    onChange: PropTypes.func,
    index: PropTypes.number,
    focusedIndex: PropTypes.number
};

export { MenuItem };
